import { PriceAndPromotionInfo, SellingPriceDnrInfo } from "../types/PriceAndPromotionInfo";

/*
    Extracts the IDs of rewardArticls of a Promotion to be able to display
    a 'free gift' badge on article cards.
*/
export function getRewardIds(priceAndPromotionInfo: PriceAndPromotionInfo, bundleId: string) {
    const dnrInfo = priceAndPromotionInfo?.dnrInfo;
    if (!dnrInfo || Object.keys(dnrInfo).length === 0) {
        return null;
    }
    let allRewards: string[] = [];
    const values = Object.values(dnrInfo);
    values.forEach((info: SellingPriceDnrInfo) => {
        if (info.rewards) {
            const rewards = info.rewards.rewardArticles && Object.keys(info.rewards.rewardArticles);
            const triggers = info.rewards.triggerArticles;
            if (triggers && bundleId in triggers && rewards) {
                allRewards = allRewards.concat(rewards);
            }
        }
    });
    return allRewards;
}
